(() => {
  if (customElements.get('early-preorder-gate')) return;
  class EarlyPreorderGate extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.check = this.querySelector('[data-ea-check]');
      this.message = this.querySelector('[data-ea-message]');
      this.consent = this.querySelector('[data-ea-consent]');
      this.agree = this.querySelector('[data-ea-agree]');
      this.check?.addEventListener('click', () => this.verify());
      this.agree?.addEventListener('change', () => this.refresh());
      this.confirmedPhase = null;
      this.nextSync = 0;
      this.onVisibility = () => { if (!document.hidden) { this.confirmedPhase = null; this.nextSync = 0; this.refresh(); } };
      document.addEventListener('visibilitychange', this.onVisibility);
      this.refresh(); this.timer = setInterval(() => this.refresh(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); this.controller?.abort(); document.removeEventListener('visibilitychange', this.onVisibility); this.ready = false; }
    phase() {
      const start = Number(this.dataset.start), end = Number(this.dataset.public), now = this.serverNow;
      if (!this.confirmedPhase || !Number.isFinite(now) || !Number.isFinite(start) || !Number.isFinite(end) || (start >= end && this.dataset.ended !== 'true')) return 'invalid';
      return now >= end ? 'public' : now < start ? 'before' : 'early';
    }
    needsSync() {
      const elapsed = (performance.now() - this.syncedAt) / 1000;
      return !this.confirmedPhase || elapsed >= 60 ||
        (this.confirmedPhase === 'before' && this.serverNow + elapsed >= Number(this.dataset.start)) ||
        (this.confirmedPhase === 'early' && this.serverNow + elapsed >= Number(this.dataset.public));
    }
    async sync() {
      if (this.syncing) return;
      this.syncing = true; this.confirmedPhase = null;
      this.controller = new AbortController();
      const timeout = setTimeout(() => this.controller.abort(), 10000);
      try {
        const url = new URL(this.dataset.productUrl, location.origin);
        if (url.origin !== location.origin) throw new Error('Invalid origin');
        url.searchParams.set('section_id', 'early-preorder-status');
        url.searchParams.set('_ea', crypto.randomUUID());
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) url.searchParams.set('preview_theme_id', preview);
        const response = await fetch(url, {credentials:'same-origin', cache:'no-store', signal:this.controller.signal});
        if (!response.ok) throw new Error('Status unavailable');
        const fresh = new DOMParser().parseFromString(await response.text(), 'text/html').querySelector('early-preorder-gate');
        const now = Number(fresh?.dataset.serverNow), start = Number(fresh?.dataset.start), end = Number(fresh?.dataset.public);
        if (!fresh || !Number.isFinite(now) || now <= 0 || !Number.isFinite(start) || !Number.isFinite(end) || (start >= end && fresh.dataset.ended !== 'true')) throw new Error('Invalid status');
        if (!this.isConnected) return;
        if (fresh.dataset.id !== this.dataset.id) { location.reload(); throw new Error('Activity changed'); }
        if (fresh.dataset.eligible !== this.dataset.eligible || fresh.dataset.loggedIn !== this.dataset.loggedIn) {
          this.verified = false; if (this.agree) this.agree.checked = false;
          if (this.consent) this.consent.hidden = true;
        }
        for (const key of ['start','public','eligible','loggedIn','ended']) this.dataset[key] = fresh.dataset[key];
        this.serverNow = now; this.syncedAt = performance.now();
        this.confirmedPhase = now >= end ? 'public' : now < start ? 'before' : 'early';
        if (this.syncError && this.message) this.message.textContent = '';
        this.syncError = false;
      } catch {
        this.confirmedPhase = null; this.syncError = true;
        if (this.message) this.message.textContent = '暫時無法確認活動狀態，請稍後重試或重新載入頁面。';
      } finally {
        clearTimeout(timeout); this.syncing = false; this.nextSync = performance.now() + 5000;
        if (this.isConnected) this.refresh();
      }
    }
    allows() { if (this.needsSync()) return false; return this.phase() === 'public' || (this.phase() === 'early' && this.dataset.loggedIn === 'true' && this.dataset.eligible === 'true' && this.verified && this.agree?.checked); }
    refresh() {
      if (this.needsSync() && !this.syncing && performance.now() >= this.nextSync && !document.hidden) this.sync();
      const phase = this.phase();
      this.dataset.locked = this.allows() ? 'false' : 'true';
      if (phase === 'public') this.setAttribute('data-public-open', ''); else this.removeAttribute('data-public-open');
      if (this.check) { this.check.disabled = phase === 'before' || phase === 'invalid'; this.check.textContent = phase === 'before' ? '優先預購尚未開始' : phase === 'invalid' ? '正在確認活動狀態' : '驗證資格並預購'; }
      const form = this.closest('product-form')?.querySelector('form');
      if (form) {
        let marker = form.querySelector('[data-ea-marker]');
        if (phase === 'early' && this.allows()) {
          if (!marker) { marker = document.createElement('input'); marker.type = 'hidden'; marker.name = 'properties[_EarlyAccessActivity]'; marker.dataset.eaMarker = ''; form.append(marker); }
          marker.value = this.dataset.id;
        } else marker?.remove();
      }
    }
    verify() {
      this.refresh(); if (this.phase() !== 'early') return;
      if (this.dataset.compact === 'true') { const link = this.querySelector('a'); if (link) location.assign(link.href); return; }
      if (this.dataset.loggedIn !== 'true') { this.message.textContent = '請先登入，再驗證優先預購資格。'; this.querySelector('[data-ea-login]').hidden = false; return; }
      if (this.dataset.eligible !== 'true') { this.message.textContent = '此帳戶尚未獲得本次優先預購資格。'; return; }
      this.verified = true; this.message.textContent = '系統初步核驗通過。請閱讀並確認以下規則，再使用預購按鈕。'; this.consent.hidden = false; this.refresh();
    }
  }
  customElements.define('early-preorder-gate', EarlyPreorderGate);
  // Catch Enter/native submits as well as existing AJAX product-form handling.
  document.addEventListener('submit', event => {
    const gate = event.target.closest('product-form')?.querySelector('early-preorder-gate');
    if (gate && !gate.allows()) { event.preventDefault(); event.stopImmediatePropagation(); gate.verify(); }
  }, true);
  window.addEventListener('pageshow', event => { if (event.persisted) location.reload(); });
})();
